import React from 'react';

import DotsLoader from '../../../DotsLoader';

import classes from './styles.module.scss';

const stepLabels = {
  preparing: 'Preparing',
  converting: 'Converting',
  merging: 'Merging',
  transcribing: 'Transcribing',
  finishing: 'Finishing',
};

const Progress = ({ isVisible, step }) => {
  const label = stepLabels[step] || step;

  return (
    <div
      className={classes.Progress}
      style={{ visibility: isVisible ? 'visible' : 'hidden' }}
    >
      <span className={classes.step}>{label}</span>
      <div className={classes.loaderContainer}>
        <DotsLoader pink />
      </div>
    </div>
  );
};

export default Progress;
